import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import { setProductIsInStock } from '../actions';
/**
 * Dialog qui s'ouvre systèmatiquement lors de l'import de commande
 * permettant de savoir si
 * @param {Boolean} isOpen                        Statut de la boite de dialog ouvert ou fermer
 * @param {Function} handleCloseDialogIsInStock   Fermeture de la boite de Dialog
 * @param {Function} dispatchSetProductIsInStock  Met à jour la donnée pour indiqué si le produit est en stock ou pas
 * @param {Function} processing                   Function permettant d'exécuter le traitement du fichier
 */
const IsInStockDialog = ({
  isOpen,
  handleCloseDialogIsInStock,
  dispatchSetProductIsInStock,
  processing
}) => (
  <div>
    <Dialog open={isOpen} onClose={() => handleCloseDialogIsInStock()}>
      <DialogContent style={{ padding: 20 }}>
        <Button
          color="primary"
          variant="contained"
          style={{ width: '100%' }}
          onClick={() => {
            dispatchSetProductIsInStock(false);
            handleCloseDialogIsInStock();
            processing();
          }}
        >
          Un coursier doit venir chercher la commande ou je l’amène chez Sympl
        </Button>
        <Button
          color="primary"
          variant="contained"
          style={{ width: '100%', marginTop: 30 }}
          onClick={() => {
            dispatchSetProductIsInStock(true);
            handleCloseDialogIsInStock();
            processing();
          }}
        >
          Les produits sont dans le stock de Sympl
        </Button>
      </DialogContent>
    </Dialog>
  </div>
);

const mapDispatchToProps = dispatch => ({
  dispatchSetProductIsInStock: isInStock =>
    dispatch(setProductIsInStock(isInStock))
});

IsInStockDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleCloseDialogIsInStock: PropTypes.func.isRequired,
  dispatchSetProductIsInStock: PropTypes.func.isRequired,
  processing: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(IsInStockDialog);
